import { useCallback } from "react";
import { toast } from "react-toastify";

const useToaster = () => {
  const toastContent = useCallback(
    ({ closeToast, message, actions }) => (
      <div className="flex items-center justify-between h-[64px] bg-[#35424D] px-4 py-3 rounded-md shadow-lg w-full">
        <span
          className="text-[14px] text-white font-semibold truncate"
          style={{ fontFamily: "Source Sans Pro" }}
        >
          {message}
        </span>
        <div className="flex items-center space-x-3">
          {actions.length > 0 ? (
            actions.map((a, i) => (
              <button
                key={i}
                onClick={() => {
                  a.action();
                  closeToast();
                }}
                className={`text-sm px-3 py-1 rounded-md ${
                  a.style || "text-blue-400 hover:text-blue-300"
                }`}
              >
                {a.text}
              </button>
            ))
          ) : (
            <button
              onClick={closeToast}
              className="text-white hover:text-gray-400 text-lg ml-2"
            >
              ✖
            </button>
          )}
        </div>
      </div>
    ),
    []
  );

  const showToast = useCallback(
    (message, actions = []) => {
      toast.dismiss();
      toast(
        ({ closeToast }) => toastContent({ closeToast, message, actions }),
        {
          autoClose: 4000,
        }
      );
    },
    [toastContent]
  );

  return showToast;
};

export default useToaster;
